<ng-container *ngIf="authorization; else noAuth">
<app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

<div class="form" style="padding-bottom: 70px">
    <div style="text-align: center; padding-bottom: 20px; padding-top: 20px">
      <h3>Compila il questionario!</h3>
      <h4>Per ogni domanda selezionare un valore da 0 a 10, dove:</h4>

      <div style="font-weight: bold; padding: 20px"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap.xs="0">
        <div class="item item-1" fxFlex="0%">0</div>
        <div class="item item-2" fxFlex="0%" fxFlexOrder="3">10</div>
        <div class="item item-3" fxFlex>5</div>
      </div>
      <div style="font-weight: bold;
       background-color: whitesmoke; padding: 20px;"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap.xs="0">
        <div class="item item-1" fxFlex="0%">Totalmente in disaccordo</div>
        <div class="item item-2" fxFlex="0%" fxFlexOrder="3">Totalmente d'accordo</div>
        <div class="item item-3" fxFlex>Né d'accordo né in disaccordo</div>
      </div>

    </div>

    <form (ngSubmit)="onSubmit()">

      <div class="container && mat-elevation-z5">

        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
          </ng-container>


          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef> Domanda </th>
            <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}} </td>
          </ng-container>


          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Descrizione </th>
            <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.description}} </td>
          </ng-container>


          <!-- TODO: forse da impostare a 0 -->
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Valore </th>
            <td mat-cell *matCellDef="let questionnaire">
              <mat-slider
                class="slider"
                [max]="10"
                [min]="0"
                [step]="1"
                [thumbLabel]="true"
                [(value)]="sliderValue[questionnaire.position - 1]"
                (change)="selectResult(questionnaire.position)">
              </mat-slider>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>

      <div style="text-align: center; display: block; padding-top: 70px; padding-bottom: 40px">
        <ng-container *ngIf="submitted">
          <div style="margin: auto; max-width: 600px">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </ng-container>

        <div style="text-align: center">
          <ng-container *ngIf="!show">
            <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia</button>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="window.innerWidth > 800">
        <div style="display: block; text-align: center; padding-top: 50px">
          <canvas baseChart #baseChart="base-chart" width="500" height="500"
                  [datasets]="radarChartData"
                  [labels]="radarChartLabels"
                  [chartType]="radarChartType"
                  [options]="radarChartOptions">

          </canvas>
        </div>
      </ng-container>
    </form>
</div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
